module.exports = __webpack_public_path__ + "resources/img/img_gridgain_apache1_m_en.00e81f7cc146dfd33f56a5c35c43c698.png";